import { inject } from '@angular/core';
import {
  Router,
  type ActivatedRouteSnapshot,
  type CanActivateFn,
} from '@angular/router';

import { AuthSelectorsFacade } from '@ps/auth-data-access';

import { isAccessLevelDenied, isRoleDenied } from '../utils/role-access.helper';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const facade = inject(AuthSelectorsFacade);
  const router = inject(Router);

  const userType = facade.userType();
  const redirectTo: string = route.data['redirectTo'] ?? '/not-found';
  const roleDeniedRedirectTo: string =
    route.data['roleDeniedRedirectTo'] ?? redirectTo;
  const accessDeniedRedirectTo: string =
    route.data['accessDeniedRedirectTo'] ?? roleDeniedRedirectTo;

  if (
    isRoleDenied(
      userType,
      route.data['roles'] ?? [],
      route.data['deniedRoles'] ?? [],
    )
  ) {
    return router.parseUrl(roleDeniedRedirectTo);
  }

  if (
    isAccessLevelDenied(
      facade.userAccessLevel(),
      route.data['accessLevel'] ?? [],
      route.data['deniedAccessLevels'] ?? [],
    )
  ) {
    return router.parseUrl(accessDeniedRedirectTo);
  }

  return true;
};
